<nav #navbar class="navbar navbar-expand-lg navbar-transparent  navbar-absolute">
  <div class="container-fluid">
    <div class="navbar-wrapper">
      <div class="navbar-minimize">
        <button mat-raised-button (click)="minimizeSidebar()" class="btn btn-just-icon btn-white btn-fab btn-round">
          <i class="material-icons text_align-center visible-on-sidebar-regular">more_vert</i>
          <i class="material-icons design_bullet-list-67 visible-on-sidebar-mini">view_list</i>
        </button>
      </div>
      <a class="navbar-brand" href="{{getPath()}}"> {{getTitle()}}</a>
    </div>
    <button mat-button class="navbar-toggler btn-no-ripple" type="button" (click)="sidebarToggle()">
      <span class="sr-only">Toggle navigation</span>
      <span class="navbar-toggler-icon icon-bar"></span>
      <span class="navbar-toggler-icon icon-bar"></span>
      <span class="navbar-toggler-icon icon-bar"></span>
    </button>

    <div class="collapse navbar-collapse justify-content-end" id="navigation" style=" position: relative;  ">
      <ul class="navbar-nav">
        <!-- Notificaciones -->
        <li class="nav-item dropdown" [ngClass]="'campana'">
          <a id="navbarDropdownMenuLink" aria-expanded="false" aria-haspopup="true" class="nav-link">
            <button mat-icon-button *ngIf="notificaciones > 0" (click)="sobreNot(true)">
              <mat-icon [ngStyle]="{'color':'white'}" matBadge="{{notificaciones}}"
                matBadgeColor="warn">{{notificaciones > 0 ? 'notifications_active':'notifications'}}</mat-icon>
            </button>
          </a>
        </li>
        <!-- Home -->
        <li class="nav-item" *ngIf="!onNotify">
          <button mat-icon-button (click)="goHome()">
            <mat-icon [ngStyle]="{'color':'white'}">dashboard</mat-icon>
          </button>
        </li>

        <!-- Desplegable -->
        <div aria-labelledby="navbarDropdownMenuLink" class='card dropdown-content' [ngClass]="'mensajes'"
          *ngIf="notificaciones > 0 && onNotify" (mouseover)="sobreNot(true)" (mouseleave)="sobreNot(false)">
          <div class='card-header card-header-success card-header-icon'>
            <div class='card-icon'>
              <i class='material-icons'>notifications</i>
            </div>
            <h4 class='card-title'> Alertas y Notificaciones </h4>
          </div>

          <div class="card-header">
            <div *ngIf='notificaciones > 0'>
              <a *ngFor="let item of listaNot" class="dropdown-item">
                <b>{{item.titulo}}</b> &nbsp; {{ item.fecha_envio | date: 'dd/MM/yyyy' }} &nbsp;

                <button mat-icon-button color="warn" (click)='marcarVisto(item)'
                  *ngIf="item.id_tipo_notificacion.id !=7">
                  <mat-icon>close</mat-icon>
                </button>
                <button mat-icon-button color="warn" (click)='openDialogCredenciales(item,0)'
                  *ngIf="item.id_tipo_notificacion.id ==7">
                  <mat-icon>check</mat-icon>
                </button>
                <button mat-icon-button color="warn" (click)='openDialogCredenciales(item,1)'
                  *ngIf="item.id_tipo_notificacion.id ==7">
                  <mat-icon>close</mat-icon>
                </button>

              </a>
            </div>
            <div class='sin-notificaciones' *ngIf='notificaciones == 0'> <br> Sin nuevas alertas y notificaciones
            </div>

            <div class='detalle'>
              <a routerLink="/notificaciones/detalle" routerLinkActive="active" class="btn btn-sm btn-finan-dos">
                <i class='material-icons'>format_list_bulleted</i> &nbsp; Ver detalles
              </a>
            </div>
            <div class='detalle'>
              <a href="javascript:void(0);" class="btn btn-sm btn-outline-danger" (click)="marcarVistoTodas()">
                <i class='material-icons'>delete_forever</i> &nbsp; Eliminar todas
              </a>
            </div>

          </div>
        </div>
      </ul>
    </div>
  </div>
</nav>